{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Élő chat kampányok",
      "NEW_CAMPAIGN": "Kampány létrehozása",
      "CARD": {
        "STATUS": {
          "ENABLED": "Engedélyezve",
          "DISABLED": "Letiltva"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Küldő",
          "BOT": "Bot",
          "FROM": "innen",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nincs elérhető élő chat kampány",
        "SUBTITLE": "Érje el ügyfeleit proaktív üzenetekkel. Kattintson a „Kampány létrehozása” gombra a kezdéshez."
      },
      "CREATE": {
        "TITLE": "Élő chat kampány létrehozása",
        "CANCEL_BUTTON_TEXT": "Mégse",
        "CREATE_BUTTON_TEXT": "Létrehozás",
        "FORM": {
          "TITLE": {
            "LABEL": "Cím",
            "PLACEHOLDER": "Kérlek írd ide a kampány nevét",
            "ERROR": "Cím megadása kötelező"
          },
          "MESSAGE": {
            "LABEL": "Üzenet",
            "PLACEHOLDER": "Kérlek írd ide a kampány üzenetét",
            "ERROR": "Üzenet kötelező"
          },
          "INBOX": {
            "LABEL": "Válassz fiókot",
            "PLACEHOLDER": "Válassz fiókot",
            "ERROR": "Fiók kötelező"
          },
          "SENT_BY": {
            "LABEL": "Küldő",
            "PLACEHOLDER": "Válassza ki a küldőt",
            "ERROR": "Küldő megadása kötelező"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Kérjük adj meg egy URL-t",
            "ERROR": "Kérjük helyes URL-t adj meg",
            "URL_IS_REGEXP": "Az érték reguláris kifejezés"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Az oldalon töltött idő (másodperc)",
            "PLACEHOLDER": "Kérlek, add meg az időtartamot",
            "ERROR": "Az oldalon töltött idő megadása kötelező"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Egyéb beállítások",
            "ENABLED": "Kampány engedélyezése",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Feloldás csak munkaidőben"
          },
          "BUTTONS": {
            "CREATE": "Létrehozás",
            "CANCEL": "Mégse"
          },
          "API": {
            "SUCCESS_MESSAGE": "Az élő chat kampány sikeresen létrejött",
            "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra."
          }
        }
      },
      "EDIT": {
        "TITLE": "Élő chat kampány szerkesztése",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Az élő chat kampány sikeresen frissült",
            "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS kampányok",
      "NEW_CAMPAIGN": "Kampány létrehozása",
      "EMPTY_STATE": {
        "TITLE": "Nincs elérhető SMS kampány",
        "SUBTITLE": "Indítson SMS kampányt, hogy közvetlenül elérje ügyfeleit. Küldjön ajánlatokat vagy közleményeket egyszerűen. Kattintson a „Kampány létrehozása” gombra a kezdéshez."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Lezárt",
          "SCHEDULED": "Ütemezett"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Küldve innen:",
          "ON": "időpont:"
        }
      },
      "CREATE": {
        "TITLE": "SMS kampány létrehozása",
        "CANCEL_BUTTON_TEXT": "Mégse",
        "CREATE_BUTTON_TEXT": "Létrehozás",
        "FORM": {
          "TITLE": {
            "LABEL": "Cím",
            "PLACEHOLDER": "Kérlek írd ide a kampány nevét",
            "ERROR": "Cím megadása kötelező"
          },
          "MESSAGE": {
            "LABEL": "Üzenet",
            "PLACEHOLDER": "Kérlek írd ide a kampány üzenetét",
            "ERROR": "Üzenet kötelező"
          },
          "INBOX": {
            "LABEL": "Válassz fiókot",
            "PLACEHOLDER": "Válassz fiókot",
            "ERROR": "Fiók kötelező"
          },
          "AUDIENCE": {
            "LABEL": "Közönség",
            "PLACEHOLDER": "Ügyfél címke kiválasztása",
            "ERROR": "Közönség megadása kötelező"
          },
          "SCHEDULED_AT": {
            "LABEL": "Tervezett idő",
            "PLACEHOLDER": "Kérlek, válaszd ki az időtartamot",
            "ERROR": "Tervezett idő megadása kötelező"
          },
          "BUTTONS": {
            "CREATE": "Létrehozás",
            "CANCEL": "Mégse"
          },
          "API": {
            "SUCCESS_MESSAGE": "Az SMS kampány sikeresen létrejött",
            "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Biztos abban, hogy törli?",
      "DESCRIPTION": "A törlés végleges, és nem vonható vissza.",
      "CONFIRM": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Kampány sikeresen törölve",
        "ERROR_MESSAGE": "Hiba történt, kérjük próbáld újra."
      }
    }
  }
}
